import { render, staticRenderFns } from "./InternalRegulation.vue?vue&type=template&id=5785d5b4&"
import script from "./InternalRegulation.vue?vue&type=script&lang=js&"
export * from "./InternalRegulation.vue?vue&type=script&lang=js&"
import style0 from "./InternalRegulation.vue?vue&type=style&index=0&id=5785d5b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports